import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { ETheme } from "../enums/user/ETheme";
import { getRGBAColor } from "../functions/getRGBAColor";
import { IUser } from "../interfaces/user/IUser";
import { darkTheme } from "../mui/theme";

const AuthLeftCard = () => {
  const { theme } = useSelector(
    (state: RootState) => state.auth.userData,
  ) as IUser;
  const { id } = useSelector((state: RootState) => state.companySettings);
  return (
    <Box
      key={id}
      sx={{
        flex: 1,
        backgroundColor:
          theme === ETheme.LIGHT
            ? getRGBAColor("--primaryColor", 0.2)
            : darkTheme.palette.background.paper,
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "center",
        margin: "10px",
        borderRadius: "10px",
      }}
    >
      <img
        src={
          theme === ETheme.LIGHT
            ? "/images/login-bg.png"
            : "/images/login-bg-dark.png"
        }
        className={"login-img"}
        alt="Login background"
      />
    </Box>
  );
};

export default AuthLeftCard;
